module.exports = __webpack_public_path__ + "static/banner-08117cd81df910f55e623e38b4bedba9.png";